<script setup lang="ts">
import { ref, onMounted } from 'vue';

const scrollComplete = ref(false);
const scrollContainer = ref<HTMLDivElement | null>(null);
const handleOnScrollIconClick = () => scrollContainer.value?.scrollBy({ behavior: 'smooth', top: 1000 });

onMounted(() => {
  const clientHeight = scrollContainer.value?.clientHeight ?? 0;
  const scrollHeight = scrollContainer.value?.scrollHeight ?? 0;
  const scrollTop = scrollContainer.value?.scrollTop ?? 0;

  scrollComplete.value = scrollTop + clientHeight + 5 >= scrollHeight;
});

const onScroll = (e: any) => {
  const clientHeight = e?.target?.clientHeight;
  const scrollHeight = e?.target?.scrollHeight;
  const scrollTop = e?.target?.scrollTop;

  if (scrollTop + clientHeight + 5 >= scrollHeight) {
    scrollComplete.value = true;
  } else {
    scrollComplete.value = false;
  }
};
</script>

<template>
  <div ref="scrollContainer" @scroll="onScroll" class="w-full overflow-auto px-4 scroll-container pb-10">
    <slot />
    <div @click="handleOnScrollIconClick" v-if="!scrollComplete" class="scroll-down"></div>
  </div>

</template>
<style lang="scss" scoped>
  .scroll-container {
    -ms-overflow-style: none;
    scrollbar-width: none; 
  }

  .scroll-container::-webkit-scrollbar {
    display: none;
  }

  .scroll-container::after {
    content: '';
    position: absolute;
    bottom: 56px;
    width: 100%;
    height: 30px;
    left: 0;
    background: linear-gradient(rgba(255, 255, 255, 0.001), rgb(58, 57, 62));
  }

  .scroll-container::before {
    content: '';
    position: absolute;
    top: 0;
    width: 100%;
    height: 60px;
    left: 0;
    background: linear-gradient(rgb(58, 57, 62), rgba(255, 255, 255, 0.001));
  }

.scroll-down {
  position: fixed;
  left: 50%;
  width: 20px;
  transform: translate(-50%);
  height: 40px;
  bottom: 2.2rem;
}

.scroll-down::before {
  animation: bounce 1s ease infinite;
  color: #fff;
  content: '╲╱';
  font-size: 10px;
  height: 1rem;
  line-height: 4rem;
  letter-spacing: -1px;
  opacity: 0.8;
  font-weight: bold;
  position: absolute;
  text-align: center;
}

@keyframes bounce {
  50% {
    transform: translateY(-30%);
  }
}
</style>
